import { ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';

export class CustomValidators {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  static passwordMatchValidator(control: AbstractControl) {
    const password: string = control.get('password')?.value; // get password from our password form control
    const repeatPassword: string = control.get('repeatPassword')?.value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== repeatPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control.get('repeatPassword')?.setErrors({ NoPassswordMatch: true });
    } else {
      if (control.get('repeatPassword')?.hasError('NoPassswordMatch')) {
        control.get('repeatPassword')?.setErrors(null);
      }
    }
  }
  static mailMatchValidator(control: AbstractControl) {
    const newMail: string = control.get('newMail')?.value; // get password from our password form control
    const repeatMail: string = control.get('repeatMail')?.value; // get password from our confirmPassword form control
    // compare is the password math
    if (newMail !== repeatMail) {
      // if they don't match, set an error in our confirmPassword form control
      control.get('repeatMail')?.setErrors({ NoMailMatch: true });
    } else {
      if (control.get('repeatPassword')?.hasError('NoMailMatch')) {
        control.get('repeatMail')?.setErrors(null);
      }
    }
  }
}
